"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = require("../actions/addReadWriteRecipient");
function useTypedAddress(recipientWell) {
    addReadWriteRecipient_1.default(recipientWell, true /* isValid */, null /* newPersona */, recipientWell.queryString);
}
exports.default = useTypedAddress;
//# sourceMappingURL=useTypedAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/useTypedAddress.js
// module id = 3081
// module chunks = 2 3